import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { AuthGuardWithForcedLogin } from './core/auth/auth-guard-with-forced-login.service';
import { BusinessTripFormComponent } from './components/forms/business-trip-form/business-trip-form.component';
import { ShortTermAssignmentFormComponent } from './components/forms/short-term-assignment-form/short-term-assignment-form.component';
import { ShouldLoginComponent } from './pages/should-login/should-login.component';
import { RoleGuard } from './core/auth/role-guard.service';
import { AuthUserRole } from './services/auth-user-role';
import { ReviewFormsComponent } from './pages/review-forms/review-forms.component';
import { ShortTermAssignmentPageComponent } from './pages/review/short-term-assignment/short-term-assignment-page.component';
import { BusinessTripPageComponent } from './pages/review/business-trip/business-trip-page.component';
import { ApprovedBusinessTripPageComponent } from './pages/approved/business-trip/approved-business-trip-page.component';
import { ApprovedShortTermAssignmentPageComponent } from './pages/approved/short-term-assignment/approved-short-term-assignment-page.component';
import { ApprovedFormsComponent } from './pages/approved-forms/approved-forms.component';
import { ErrorPageComponent } from './pages/error/error.component';
import { ErrorLayoutComponent } from './layout/error-layout/error-layout.component';
import { AllFormsPageComponent } from './pages/all-forms-page/all-forms-page.component';
import { EhsReviewPageComponent } from './pages/ehs-review-page/ehs-review-page.component';
import { ReviewType } from './services/data/review-type';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },

    {
        path: '',
        component: MainLayoutComponent,
        children: [
            {
                path: 'home',
                component: HomeComponent,
                canActivate: [AuthGuardWithForcedLogin]
            },
            {
                path: 'form/stv/:id',
                component: BusinessTripFormComponent,
                canActivate: [AuthGuardWithForcedLogin],
            },
            {
                path: 'form/sta/:id',
                component: ShortTermAssignmentFormComponent,
                canActivate: [AuthGuardWithForcedLogin],
            },
            {
                path: 'hr-review',
                component: ReviewFormsComponent,
                canActivate: [AuthGuardWithForcedLogin, RoleGuard], 
                data: { roles: [AuthUserRole.HRReviewer] },
            },
            {
                path: 'hr-review/stv/:id',
                component: BusinessTripPageComponent,
                canActivate: [AuthGuardWithForcedLogin, RoleGuard], 
                data: { roles: [AuthUserRole.HRReviewer], reviewType: ReviewType.HR },
            },
            {
                path: 'hr-review/sta/:id',
                component: ShortTermAssignmentPageComponent,
                canActivate: [AuthGuardWithForcedLogin, RoleGuard], 
                data: { roles: [AuthUserRole.HRReviewer], reviewType: ReviewType.HR },
            },
            {
                path: 'ehs-review',
                component: EhsReviewPageComponent,
                canActivate: [AuthGuardWithForcedLogin, RoleGuard], 
                data: { roles: [AuthUserRole.EHSReviewer] },
            },
            {
                path: 'ehs-review/stv/:id',
                component: BusinessTripPageComponent,
                canActivate: [AuthGuardWithForcedLogin, RoleGuard], 
                data: { roles: [AuthUserRole.EHSReviewer], reviewType: ReviewType.EHS },
            },
            {
                path: 'ehs-review/sta/:id',
                component: ShortTermAssignmentPageComponent,
                canActivate: [AuthGuardWithForcedLogin, RoleGuard], 
                data: { roles: [AuthUserRole.EHSReviewer], reviewType: ReviewType.EHS },
            },
            {
                path: 'approved',
                component: ApprovedFormsComponent,
                canActivate: [AuthGuardWithForcedLogin, RoleGuard], 
                data: { roles: [AuthUserRole.HRReviewer, AuthUserRole.EHSReviewer] },
            },
            {
                path: 'view/stv/:id',
                component: ApprovedBusinessTripPageComponent,
                canActivate: [AuthGuardWithForcedLogin, RoleGuard], 
                data: { roles: [AuthUserRole.HRReviewer, AuthUserRole.EHSReviewer] },
            },
            {
                path: 'view/sta/:id',
                component: ApprovedShortTermAssignmentPageComponent,
                canActivate: [AuthGuardWithForcedLogin, RoleGuard], 
                data: { roles: [AuthUserRole.HRReviewer, AuthUserRole.EHSReviewer] },
            },
            {
                path: 'all',
                component: AllFormsPageComponent,
                canActivate: [AuthGuardWithForcedLogin, RoleGuard], 
                data: { roles: [AuthUserRole.HRReviewer, AuthUserRole.EHSReviewer] },
            }
        ]
    },

    {
        path: '',
        component: ErrorLayoutComponent,
        children: [
            {
                path: 'error',
                component: ErrorPageComponent,
            },
            { 
                path: 'should-login', 
                component: ShouldLoginComponent 
            },
            { 
                path: '**', 
                component: PageNotFoundComponent 
            }
        ]
    }
];
